import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card, NavLink } from 'react-bootstrap';
import { AppContext } from '../../../AppContext'; // adjust path as needed

const Faqs = () => {
    const { appState } = useContext(AppContext);
    const { title, placeholder, button, section, support, items } = appState.faqs || {};

    if (!items?.[0]) {
        return
    }


    return (
        <section className="section-padding loan-faqs-sec bg-light-white findrate-top">
            {/* <div className="container">
                <div className="row">
                    <div className="offset-lg-2 col-lg-8">
                        <div className="findratesec">
                            <h3 className="text-custom-black">{title}</h3>
                            <div className="input-form-box">
                                <form>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control form-control-custom"
                                            placeholder={placeholder}
                                        />
                                        <div className="input-group-append">
                                            <button type="submit" className="btn-first btn-submit-fill">
                                                {button}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="container mt-5">
                <div className="row">
                    {/* Left Column - Support Info */}
                    <div className="col-xl-5 col-lg-6 align-self-center">
                        <div className="section-header">
                            <div className="section-heading">
                                <h3 className="text-custom-black fw-700">{section.heading}</h3>
                                <div className="section-description">
                                    <p className="text-light-white no-margin">{section.subtext}</p>
                                </div>
                            </div>
                        </div>
                        <div className="loan-faqs-leftside mb-md-80">
                            <div className="support-card mb-xl-20">
                                <div className="support-user">
                                    <img src={process.env.PUBLIC_URL + support.image} className="image-fit" alt="support" />
                                </div>
                                <div className="links text-center mb-xl-20">
                                    <Link to="#">{support.email}</Link>
                                    <Link to="#">{support.phone}</Link>
                                    <Link to="#">{support.chat}</Link>
                                </div>
                                <div className="schdule">
                                    <ul className="custom">
                                        {support.schedule.map((item, i) => (
                                            <li key={i}>
                                                {item.day} <span className="text-light-white">{item.time}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <Link to="#" className="btn-first btn-submit-fill">Chat With Us</Link>
                        </div>
                    </div>

                    {/* Right Column - FAQ Accordion */}
                    <div className="col-xl-7 col-lg-6 align-self-center">
                        <Accordion defaultActiveKey="0" className="faqs-accordion">
                            {items.map((faq, i) => (
                                <Card key={i}>
                                    <Accordion.Collapse eventKey={String(i)} className="collapseparent">
                                        <Card.Body>
                                            {faq.answer.map((text, j) => (
                                                <p key={j} className={`text-light-white ${j === faq.answer.length - 1 ? 'no-margin' : ''}`}>
                                                    {text?.label}
                                                </p>
                                            ))}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                    <Card.Header>
                                        <Accordion.Toggle as={NavLink} className="collapsebtn" variant="link" eventKey={String(i)}>
                                            {faq.question}
                                        </Accordion.Toggle>
                                    </Card.Header>
                                </Card>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faqs;
